import { render, staticRenderFns } from "./gongsi.vue?vue&type=template&id=818bb96e&scoped=true&"
import script from "./gongsi.vue?vue&type=script&lang=js&"
export * from "./gongsi.vue?vue&type=script&lang=js&"
import style0 from "./gongsi.vue?vue&type=style&index=0&id=818bb96e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818bb96e",
  null
  
)

export default component.exports